const defaultColors = [
  '#FF691F',
  '#FAB81E',
  '#7FDBB6',
  '#19CF86',
  '#91D2FA',
  '#1B95E0',
  '#B71C1C',
  '#E81C4F',
  '#F58EA8',
  '#981CEB',
];

export default defaultColors;
